import { api } from './api';

export type FxRateKind = 'avg' | 'period_end' | 'historical';

export interface FxRate {
  id: string;
  workspaceId: string;
  date: string;
  fromCurrency: string;
  toCurrency: string;
  kind: FxRateKind;
  rate: number;
  createdAt: string;
}

export interface UpsertFxRateBody {
  date: string;
  fromCurrency: string;
  toCurrency: string;
  kind: FxRateKind;
  rate: number;
}

export const fxRatesApi = {
  async list(workspaceId: string, opts: { from?: string; to?: string; kind?: FxRateKind; since?: string; until?: string } = {}): Promise<FxRate[]> {
    const r = await api.get<FxRate[]>(
      `/api/workspaces/${workspaceId}/fx-rates`,
      { params: opts },
    );
    return r.data;
  },
  async upsert(workspaceId: string, body: UpsertFxRateBody): Promise<FxRate> {
    const r = await api.post<FxRate>(`/api/workspaces/${workspaceId}/fx-rates`, body);
    return r.data;
  },
  /** Pull a live spot rate from the server's provider (Frankfurter / ECB). */
  async fetchLive(workspaceId: string, body: { fromCurrency: string; toCurrency: string; kind?: FxRateKind }): Promise<FxRate> {
    const r = await api.post<FxRate>(`/api/workspaces/${workspaceId}/fx-rates/fetch`, body);
    return r.data;
  },
  async delete(id: string): Promise<void> {
    await api.delete(`/api/fx-rates/${id}`);
  },
};
